
var id = "uploadImg";
var markup = "<symbol viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"uploadImg\">\n    <title>切片</title>\n    <defs>\n        <path d=\"M32,10 L32,15.98 C32,15.98 28.02,16 28,15.98 L28,10 L22,10 C22,10 22.02,6.02 22,6 L28,6 L28,0 L32,0 L32,6 L38,6 L38,10 L32,10 Z M26,18 L26,12 L20,12 L20,6 L4,6 C1.8,6 0,7.8 0,10 L0,34 C0,36.2 1.8,38 4,38 L28,38 C30.2,38 32,36.2 32,34 L32,18 L26,18 Z M4,34 L10,26 L14,32 L20,24 L28,34 L4,34 Z\" id=\"uploadImg_path-1\" />\n    </defs>\n    <g id=\"uploadImg_微信管理（fa）\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"uploadImg_微信管理-/-自动回复-/新建规则(小程序卡片)\" transform=\"translate(-418.000000, -680.000000)\">\n            <g id=\"uploadImg_区块-添加度担心模板\" transform=\"translate(280.000000, 145.000000)\">\n                <g id=\"uploadImg_*详情图\" transform=\"translate(64.000000, 453.000000)\">\n                    <g id=\"uploadImg_btn-详情图\" transform=\"translate(0.000000, 28.000000)\">\n                        <g id=\"uploadImg_34.-Icons/filled/image/add_photo_alternate_24px\" transform=\"translate(80.000000, 58.000000)\">\n                            <mask id=\"uploadImg_mask-2\" fill=\"white\">\n                                <use xlink:href=\"#uploadImg_path-1\" />\n                            </mask>\n                            <use id=\"uploadImg_icon/image/add_photo_alternate_24px\" fill-opacity=\"0.87\" fill=\"#000000\" xlink:href=\"#uploadImg_path-1\" />\n                        </g>\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
